import * as yup from 'yup';

const spotifyRegex = /(^(https:\/\/open.spotify.com\/track\/)([\S\d]{22}))|(^(spotify:track:)([\S\d]{22})$)/;
export const createSongSchema = yup.object().shape({
  spotifyUri: yup
    .string()
    .trim()
    .matches(
      spotifyRegex,
      'Spotify link must start with "https" or "spotify:track:" (ex. https://open.spotify.com/track/xxxxxxxxxxxxxxxxxxxxxx or spotify:track:xxxxxxxxxxxxxxxxxxxxxx',
    )
    .required('Please enter your Spotify URI'),
  trackName: yup.string().required('Please enter the track name'),
  artist: yup.string().required('Please enter an artist name'),
});
